<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();

const channels = computed(() => [
  {
    key: 'whatsapp',
    icon: 'i-woot-whatsapp',
    title: t('CAMPAIGN.CHANNELS.WHATSAPP.TITLE'),
    description: t('CAMPAIGN.CHANNELS.WHATSAPP.DESCRIPTION'),
    route: { name: 'campaigns_whatsapp_index' },
  },
  {
    key: 'live_chat',
    icon: 'i-lucide-message-square',
    title: t('CAMPAIGN.CHANNELS.LIVE_CHAT.TITLE'),
    description: t('CAMPAIGN.CHANNELS.LIVE_CHAT.DESCRIPTION'),
    route: { name: 'campaigns_livechat_index' },
  },
  {
    key: 'sms',
    icon: 'i-woot-sms',
    title: t('CAMPAIGN.CHANNELS.SMS.TITLE'),
    description: t('CAMPAIGN.CHANNELS.SMS.DESCRIPTION'),
    route: { name: 'campaigns_sms_index' },
  },
]);

const selectChannel = channel => {
  router.push(channel.route);
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10 px-6 bg-n-surface-1">
      <div class="w-full max-w-5xl mx-auto">
        <div class="flex items-center justify-between w-full h-20 gap-2">
          <div class="min-w-0">
            <h1 class="text-heading-1 text-n-slate-12">
              {{ t('CAMPAIGN.CHANNELS.TITLE') }}
            </h1>
            <p class="mt-1 text-sm text-n-slate-11">
              {{ t('CAMPAIGN.CHANNELS.SUBTITLE') }}
            </p>
          </div>
        </div>
      </div>
    </header>

    <main class="flex-1 px-6 overflow-y-auto">
      <div class="w-full max-w-5xl mx-auto py-6">
        <div class="divide-y divide-n-weak border-t border-n-weak">
          <button
            v-for="channel in channels"
            :key="channel.key"
            type="button"
            class="w-full flex items-start justify-between gap-4 px-4 py-5 -mx-4 text-left rounded-lg hover:bg-n-alpha-1 transition-colors"
            @click="selectChannel(channel)"
          >
            <div class="flex items-start gap-4 min-w-0">
              <span
                class="grid place-items-center size-10 rounded-lg bg-n-alpha-2 text-n-slate-11 flex-shrink-0"
              >
                <span class="size-5" :class="[channel.icon]" />
              </span>
              <span class="min-w-0">
                <span class="block text-base font-semibold text-n-slate-12">
                  {{ channel.title }}
                </span>
                <span class="block mt-1 text-sm text-n-slate-11">
                  {{ channel.description }}
                </span>
              </span>
            </div>
            <span class="i-lucide-chevron-right size-4 text-n-slate-8 mt-3" />
          </button>
        </div>
      </div>
    </main>
  </section>
</template>
